import { render } from "./InactiveMedications.vue?vue&type=template&id=f6bb7c1a&scoped=true"
import script from "./InactiveMedications.vue?vue&type=script&lang=js"
export * from "./InactiveMedications.vue?vue&type=script&lang=js"

import "./InactiveMedications.vue?vue&type=style&index=0&id=f6bb7c1a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6bb7c1a"]])

export default __exports__